import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { IonLabel, IonSegment, IonSegmentButton } from '@ionic/react';
import { Inbox } from 'lucide-react';
import { EmptyState, ErrorState, Skeleton } from '@tcrd/ui';
import { Page } from '../../../components/Page';
import { RequestCard } from '../../../components/TripCards';
import { api, errorMessage } from '../../../lib/api';
import type { RideRequestDto } from '../../../lib/types';
import { ComplianceBanner } from '../documents/DocumentsPage';

const FILTERS = {
  new: 'REQUESTED,INFO_REQUESTED',
  quoted: 'QUOTED',
  closed: 'CONFIRMED,REJECTED,CANCELLED,EXPIRED',
} as const;

export function RequestsInboxPage() {
  const [tab, setTab] = useState<keyof typeof FILTERS>('new');
  const q = useQuery({ queryKey: ['ride-requests', 'inbox', tab], queryFn: () => api<RideRequestDto[]>('/ride-requests', { query: { status: FILTERS[tab] } }) });

  return (
    <Page title="Solicitudes" onRefresh={() => q.refetch()}>
      <div className="flex flex-col gap-4">
        <ComplianceBanner />
        <IonSegment value={tab} onIonChange={(e) => setTab(e.detail.value as keyof typeof FILTERS)}>
          <IonSegmentButton value="new"><IonLabel>Nuevas</IonLabel></IonSegmentButton>
          <IonSegmentButton value="quoted"><IonLabel>Cotizadas</IonLabel></IonSegmentButton>
          <IonSegmentButton value="closed"><IonLabel>Cerradas</IonLabel></IonSegmentButton>
        </IonSegment>
        {q.isLoading && <Skeleton className="h-32" />}
        {q.error && <ErrorState message={errorMessage(q.error)} onRetry={() => q.refetch()} />}
        {q.data?.length === 0 && <EmptyState icon={<Inbox className="size-6" />} title={tab === 'new' ? 'Sin solicitudes nuevas' : 'Nada por aquí'} description="Las nuevas solicitudes llegan con notificación." />}
        {q.data?.map((r) => <RequestCard key={r.id} r={r} href={`/driver/requests/${r.id}`} />)}
      </div>
    </Page>
  );
}
